import { render, staticRenderFns } from "./IPRCurve.vue?vue&type=template&id=6e5ea138&"
import script from "./IPRCurve.vue?vue&type=script&lang=js&"
export * from "./IPRCurve.vue?vue&type=script&lang=js&"
import style0 from "./IPRCurve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports